<template>
  <Modal title="添加活动" v-model="visible">
        <Form class="form" ref="createActivityForm" :rules="activityRules" :model="createActivityParams">
            <Row>
                <FormItem :label-width="90" label="活动名称：" prop="name">
                    <Input v-model="createActivityParams.name" placeholder="请输入活动名称用于列表展示"></Input>
                </FormItem>
                <FormItem :label-width="90" label="活动分类：" prop="activityType">
                    <Select v-model="createActivityParams.activityType" clearable>
                        <Option v-for="item in $constant.activityType" :value="item.code" :key="item.code">{{ item.text }}</Option>
                    </Select>
                </FormItem>
                <FormItem :label-width="90" label="活动时间：" prop="activityTime">
                    <DatePicker v-model="time" @on-change="timeDateChange" format="yyyy-MM-dd" type="daterange" placement="bottom-start" placeholder="选择起始时间"></DatePicker>
                </FormItem>
                <FormItem :label-width="90" label="活动标识：" prop="tag">
                    <Input v-model="createActivityParams.tag" placeholder="请输入活动标识"></Input>
                </FormItem>
                <FormItem :label-width="90" label="活动状态：" prop="status">
                    <Select v-model="createActivityParams.status" clearable>
                        <Option value="1" key="1">启用</Option>
                        <Option value="0" key="2">禁用</Option>
                    </Select>
                </FormItem>
                <FormItem :label-width="90" label="活动说明：">
                    <Input v-model="createActivityParams.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入活动描述" />
                </FormItem>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="text" size="large" @click="visible = false">取消</Button>
            <Button type="primary" size="large" :loading="loadingAddActivity" @click="createActivity">确定</Button>
        </div>
    </Modal>
</template>
<script>
export default {
  name: 'CreateActivityModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let $constant = this.$constant
    return {
      visible: this.value,
      bookMaterialLevelList: null,
      loadingAddActivity: false,
      adviserList: [],
      time: [],
			createActivityParams: {
				id: 0,
				name: '',
				activityType: '',
				tag: '',
				startTimeStr: '',
				endTimeStr: '',
				status: '',
				description: '',
				createTime: '',
				updateTime: ''
			},
			activityRules: {
				name: [
						{ type: 'string', required: true, message: '请输入活动名称', trigger: 'blur' }
				],
				activityType: [
						{ required: true, message: '请选择活动分类', trigger: 'blur' }
				],
				activityTime: [
          { type: 'array', required: true, fields: {
            0: { required: true, message: ' ', trigger: 'change' },
            1: { required: true, message: ' ', trigger: 'change' }
          }}
				],
				tag: [
						{ type: 'string', required: true, message: '请输入活动参数', trigger: 'blur' }
				],
				status: [
						{ required: true, message: '请选择活动状态', trigger: 'blur' }
				]
			}
    }
  },
  methods: {
    timeDateChange(value){
			console.log(`value`, value)
			let self = this
			self.createActivityParams.startTimeStr = value[0] + ' 00:00:00'
			self.createActivityParams.endTimeStr = value[1] + ' 23:59:59'
    },
    createActivity () {
      let self = this
      self.loadingAddActivity = true
      self.$refs.createActivityForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingAddActivity = false
          return
        }
        self.$http.post('/activity/save', self.createActivityParams).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false
            self.$Message.success('创建成功!')
            self.successCallback()
          }
          self.loadingAddActivity = false
        }).catch(function (e) {
          self.showAddActivityModal = false
          self.loadingAddActivity = false
        })
      })
    }
  },
  watch: {
    value (val) {
      this.visible = val
    },
    visible (val) {
      if (val === true) {
        this.createActivityParams = {
            id: 0,
            name: '',
            activityType: '',
            tag: '',
            startTimeStr: '',
            endTimeStr: '',
            status: '',
            description: '',
            createTime: '',
            updateTime: ''
        }
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateActivityModal.vue?3be4ca5a